/* eslint-disable unicorn/numeric-separators-style */
import { StoryData } from '@cinch-nx/data-storyblok'
import { BrandPageStory } from '../storyblok'
import { BydBrandPageFallbackStory } from './byd-fallbak-json'
import { JaecooBrandPageFallbackStory } from './jaecoo-fallback-json'
import { OmodaBrandPageFallbackStory } from './omoda-fallback-json'

export const BRAND_SLUGS = ['byd', 'jaecoo', 'omoda'] as const
export type BrandSlugs = (typeof BRAND_SLUGS)[number]
export type BrandPageFallbacks = Record<BrandSlugs, StoryData<BrandPageStory>>

export const brandPageFallbackStory: BrandPageFallbacks = {
  byd: BydBrandPageFallbackStory,
  jaecoo: JaecooBrandPageFallbackStory,
  omoda: OmodaBrandPageFallbackStory,
}
